export const generalstate = {
	user: {},
	token: null,
	brandname: 'AumeHome',
	wishlist: [],
    viewed: [],    
	isLoggedIn: false,
}
